import { AppError } from './AppError';

/**
 * guard to check if an error is an `AppError`
 * @param err the potential app error
 */
export function isAppError(err: unknown): err is AppError {
  return err instanceof AppError;
}
